import type { Moment } from 'moment';
import moment from './moment';

export const getLocaleDateString = (date: string): string =>
  new Date(date).toLocaleDateString('ja-JP');

export const getLocaleEndDateString = (date: string | Date): string => {
  const momentDate = getSubstractedDateIfNeeded(date);
  return getLocaleDateString(momentDate.toISOString(true));
};

const getSubstractedDateIfNeeded = (date: string | Date): Moment => {
  const momentDate = moment(date);
  return isMidNight(momentDate) ? momentDate.subtract(1, 'd') : momentDate;
};

const isMidNight = (momentDate): boolean =>
  momentDate.hours() === 0 &&
  momentDate.minutes() === 0 &&
  momentDate.seconds() === 0;
